import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';
import { useExample } from '../../hooks/useSwr';

export function ExampleCrumb(props: Partial<BreadcrumbData>) {
  const { exampleId } = useParams();
  const example = useExample(exampleId!);

  return (
    <Breadcrumb
      name={example.data ? `Example: ${example.data.name}` : ''}
      {...props}
    />
  );
}
